<p-popover #op (onHide)="onPopoverHide()">
  <div class="flex flex-col gap-4 min-w-[194px]">
    @if (view() === 'main') {
    <div>
      <ul class="list-none p-0 m-0 flex flex-col">
        @for (option of options; track option.id) {
        <li
          class="flex items-center gap-2 px-2 py-3 hover:bg-[var(--bg-surface-hover)] cursor-pointer rounded-border"
          (click)="selectOption(option)"
        >
          <img [src]="'assets/icons/' + option.image" />
          <div>
            <span class="qbrain-text-base qbrain-text-primary">{{
              option.name | translate
            }}</span>
          </div>
        </li>
        }
      </ul>
    </div>
    } @else {
    <div>
      <div
        class="flex items-center gap-2 px-2 py-3 cursor-pointer rounded-border hover:bg-[var(--bg-surface-hover)]"
        (click)="backToMain()"
      >
        <img src="assets/icons/back.svg" alt="" />
        <span class="qbrain-text-base qbrain-text-primary font-medium">{{
          'common.languageMenu.title' | translate
        }}</span>
      </div>
      <ul class="list-none p-0 m-0 flex flex-col">
        @for (lang of languageOptions; track lang.code) {
        <li
          class="flex items-center justify-between gap-2 px-2 py-3 hover:bg-[var(--bg-surface-hover)] cursor-pointer rounded-border"
          (click)="selectLanguage(lang.code)"
        >
          <span class="qbrain-text-base qbrain-text-primary">{{ lang.codeLabel }} - {{ lang.nameKey | translate }}</span>
          @if (activeLang() === lang.code) {
          <img src="assets/icons/check-fill.svg" alt="" />
          }
        </li>
        }
      </ul>
    </div>
    }
  </div>
</p-popover>
